import { Component, Input, ViewChild, OnInit} from '@angular/core';
import { ApiService } from '../../services/api.service';
import { CustomStore } from 'devextreme-angular/common/data';
import { DecimalPipe, DatePipe, NgIf } from '@angular/common';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
  
@Component({
  selector: 'app-host-detail-grid',
  imports: [DxDataGridModule, DecimalPipe, DatePipe, NgIf],
  templateUrl: './host-detail-grid.component.html',
  styleUrl: './host-detail-grid.component.css'
})
export class HostDetailGridComponent implements OnInit {
  @ViewChild('dataGrid') dataGrid!: DxDataGridComponent;
  @Input() hostname!: string;

  dataStore: any;

  constructor(private apiService: ApiService) { }

  ngOnInit() {
    this.createDataStore();
  }

    private createDataStore() {
    this.dataStore = this.apiService.createHostDetailStore(this.hostname);
  }

}
